import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconNoData100pxBoldLightS = function IconNoData100pxBoldLightS(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 100 100",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M11.156 16.57A5.417 5.417 0 0116.571 11h63.173c5.07 0 9.139 4.185 8.996 9.252l-1.495 53.322a9 9 0 01-8.996 8.748H21.75a9 9 0 01-8.996-8.748L11.156 16.57z",
      fill: "#C5CBD6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M82.494 29.38L70.45 17.452c-1.143.808-5.472 2.637-5.919 3.382-.447.746-2.472 5.43-3.429 7.678L77.8 34.14l4.694-4.758z",
      fill: "#E4E7ED"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.637 20.589a3 3 0 012.998-3.11h49.818v8.894a3 3 0 003 3h9.006l-1.866 39.755a3 3 0 01-2.997 2.86h-55.18a3 3 0 01-2.999-2.89l-1.78-48.509z",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.231 34.282A6.059 6.059 0 0112.286 28H31.1a9 9 0 015.66 2.003l6.049 4.893a9 9 0 005.66 2.003h35.847c5.23 0 9.358 4.442 8.976 9.657l-2.01 27.424a9 9 0 01-8.975 8.342H16.675a9 9 0 01-8.994-8.669L6.23 34.281z",
      fill: "#E4E7ED"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M81.486 63.028a9.37 9.37 0 11-18.739 0 9.37 9.37 0 0118.739 0zM80.4 75.975a15.296 15.296 0 01-8.285 2.422c-8.488 0-15.369-6.88-15.369-15.369 0-8.488 6.881-15.37 15.37-15.37 8.487 0 15.369 6.882 15.369 15.37 0 3.268-1.02 6.297-2.759 8.788l9.051 9.05a3 3 0 11-4.243 4.243l-9.134-9.134z",
      fill: "#C5CBD6"
    })]
  }));
};
export default IconNoData100pxBoldLightS;